/*
 * mm-empire-cart-bridge.js
 *
 * Garden-free glue between the ported mm-quick-add popover and Empire's native
 * cart. It provides the two globals mm-quick-add.js looks for:
 *
 *   window.MiniCart                 -> used for the "Add to Cart" path
 *   window.MrMapleSingleItemCheckout -> used for the "Buy Now" path
 *
 * Add to Cart:  POST /cart/add.js, then refresh Empire's header cart count via
 *               the `cartcount:update` event it already listens for.
 * Buy Now:      POST /cart/add.js, then redirect to /checkout (no app proxy).
 *
 * This intentionally does NOT depend on the Garden app proxy.
 */
(function () {
  'use strict';

  function routePath(path) {
    var root = '/';
    try {
      root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
        ? window.Shopify.routes.root
        : '/';
    } catch (e) {
      root = '/';
    }
    return root.replace(/\/?$/, '/') + String(path || '').replace(/^\//, '');
  }

  function postJson(url, body, fallbackMessage) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.text().then(function (text) {
        var payload = null;
        if (text) {
          try { payload = JSON.parse(text); } catch (e) { payload = null; }
        }
        if (!response.ok) {
          var message = (payload && (payload.description || payload.message || payload.error)) || fallbackMessage;
          var error = new Error(message);
          error.status = response.status;
          error.payload = payload;
          throw error;
        }
        return payload;
      });
    });
  }

  // Pull the live cart and tell Empire's header to update its badge.
  function refreshCartCount() {
    return fetch(routePath('cart.js'), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        if (!cart) return null;
        try {
          window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart }));
        } catch (e) { /* no-op */ }
        try {
          document.dispatchEvent(new CustomEvent('addToCartFlyout:complete', {
            detail: { responseData: cart, success: true }
          }));
        } catch (e) { /* no-op */ }
        return cart;
      })
      .catch(function () { return null; });
  }

  if (!window.MiniCart) {
    window.MiniCart = {
      // items: [{ id, quantity, properties?, selling_plan? }]
      addItems: function (items, options) {
        var payload = { items: Array.isArray(items) ? items : [items] };
        return postJson(routePath('cart/add.js'), payload, 'Failed to add to cart')
          .then(function (data) {
            return refreshCartCount().then(function () { return data; });
          });
      },
      refresh: function () {
        return refreshCartCount();
      },
      open: function () {
        // Empire has no cart drawer; the header badge update is the feedback.
        return Promise.resolve();
      }
    };
  }

  if (!window.MrMapleSingleItemCheckout) {
    window.MrMapleSingleItemCheckout = {
      // Garden-free Buy Now: add the single item to the cart, then go to checkout.
      start: function (options) {
        var config = options || {};
        var item = config.item || {};
        var line = {
          id: item.id,
          quantity: item.quantity && item.quantity > 0 ? item.quantity : 1
        };
        if (item.properties && Object.keys(item.properties).length) {
          line.properties = item.properties;
        }
        if (item.selling_plan) {
          line.selling_plan = item.selling_plan;
        }

        if (typeof config.setLoading === 'function') {
          config.setLoading(true);
        }

        return postJson(routePath('cart/add.js'), { items: [line] }, 'Unable to start checkout.')
          .then(function () {
            var query = typeof config.checkoutQuery === 'string' ? config.checkoutQuery : '';
            window.location.href = routePath('checkout') + query;
          })
          .catch(function (error) {
            if (typeof config.setLoading === 'function') {
              config.setLoading(false);
            }
            throw error;
          });
      }
    };
  }
})();
